import { useReportsViewAddFromCatalog } from "@/app/app/_/views/ReportsView/ReportsViewAssembleDndContext";
import { useReportsViewReportLayoutContextOrNull } from "@/app/app/_/views/ReportsView/ReportsViewReportLayoutContext";
import { useReportSourceCatalog } from "@/app/app/_/views/ReportsView/reportFilterDefinitions.hooks";
import {
  ReportsViewCatalogSection,
  ReportsViewSourceCatalogItem,
} from "@/app/app/_/views/ReportsView/ReportsView.utils";
import { useDevice } from "@/hooks/useDevice";
import { State } from "@/state";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * What there is to chart, to drag onto the report.
 *
 * Only the subjects: how a chart is drawn is chosen on the card itself, where
 * it can be seen. Dragging a bar chart onto a canvas and being asked what it
 * was of put the question the wrong way round - nobody decides on a bar chart
 * before they decide what they want to look at.
 *
 * Or tapped - a finger cannot drag across a phone's screen, where this list
 * covers the report, nor a mouse across a window as narrow - and it goes to
 * the end of the report. There the list then goes, so what was added is
 * there to be seen.
 */
export function ReportsViewWidgetSource() {
  const sources = useReportSourceCatalog();

  // The canvas has no drop target until its definition lands — it is still
  // showing its own skeleton — and a drop before then is dropped on the floor.
  // Hold the sources closed until it can take one; the report query can take
  // seconds when the widget content queries are ahead of it in the queue.
  const layout = useReportsViewReportLayoutContextOrNull();
  const dragDisabled = layout?.activeDefinition == null;
  const addFromCatalog = useReportsViewAddFromCatalog();
  const { isMobile, isNarrow } = useDevice();
  const add = addFromCatalog
    ? (id: string) => {
        addFromCatalog(id);
        if (isNarrow) {
          State.getState().setIsNodePanelOpen(false);
          State.getState().setSnackbarMessage(
            "Added at the end of the report.",
          );
        }
      }
    : undefined;

  return (
    <div className="flex flex-col h-full min-h-0 overflow-y-auto pl-3 pr-3 pt-3 pb-3">
      <ReportsViewCatalogSection
        title={
          isNarrow
            ? `${isMobile ? "Tap" : "Click"} to add to the report`
            : "Drag onto the report"
        }
      >
        {sources.length === 0
          ? // The shape of the list it is about to be, rather than a word about
            // waiting for it.
            Array.from({ length: 6 }).map((_unused, index) => (
              <Skeleton
                key={index}
                variant="rectangular"
                height={44}
                className="rounded-lg relative"
              />
            ))
          : sources.map((source) => (
              <ReportsViewSourceCatalogItem
                key={source.name}
                source={source}
                dragDisabled={dragDisabled}
                onAdd={add}
              />
            ))}
      </ReportsViewCatalogSection>
    </div>
  );
}
